import { Link, useLocation } from '@tanstack/react-router';
import { 
  LayoutDashboard, 
  Users, 
  Server, 
  Box, 
  Settings,
  Activity,
  LogOut,
  Zap
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { ThemeToggle } from '@/components/ThemeToggle';

const navItems = [
  { path: '/', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/customers', label: 'Customers', icon: Users },
  { path: '/instances', label: 'Instances', icon: Box },
  { path: '/servers', label: 'Servers', icon: Server },
  { path: '/events', label: 'Events', icon: Activity },
  { path: '/settings', label: 'Settings', icon: Settings },
];

// Desktop Sidebar only
export function DesktopSidebar() {
  const location = useLocation();
  
  const handleLogout = () => {
    localStorage.removeItem('admin_api_key');
    window.location.reload();
  };

  return (
    <div className="hidden md:flex h-screen w-56 flex-col border-r border-sidebar-border bg-sidebar">
      {/* Logo */}
      <div className="flex h-16 items-center border-b border-sidebar-border px-4">
        <Link to="/" className="flex items-center gap-2.5 font-semibold text-foreground">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-foreground">
            <Zap className="h-4 w-4 text-background" />
          </div>
          <span className="text-sm">ClawdBot Factory</span>
        </Link>
      </div>
      
      {/* Nav Items */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path !== '/' && location.pathname.startsWith(item.path));
          const Icon = item.icon;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all duration-150",
                isActive 
                  ? "bg-sidebar-accent text-sidebar-accent-foreground" 
                  : "text-sidebar-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground"
              )}
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>
      
      {/* Footer: Theme Toggle + Logout */}
      <div className="border-t border-sidebar-border p-3 space-y-1">
        <ThemeToggle showLabel className="w-full" />
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-sidebar-foreground transition-all duration-150 hover:bg-status-error/20 hover:text-status-error-foreground"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
      </div>
    </div>
  );
}

// Legacy export
export function Sidebar() {
  return <DesktopSidebar />;
}

// No mobile header needed - using bottom nav instead
export function MobileHeader() {
  return null;
}
